import React, { useEffect, useRef } from "react";
import { useApp } from "@/context/AppProvider";
import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";

// Inline click-to-edit text. Commits on blur.
export const EditableText = ({ path, value, as = "span", className = "", style, multiline = false }) => {
  const { editMode, update } = useApp();
  const ref = useRef(null);
  const Tag = as;

  useEffect(() => {
    if (editMode && ref.current && ref.current.innerText !== value) {
      ref.current.innerText = value ?? "";
    }
  }, [editMode, value]);

  if (!editMode) {
    return (
      <Tag className={className} style={style}>
        {value}
      </Tag>
    );
  }
  return (
    <Tag
      ref={ref}
      className={`${className} editable-text`}
      style={style}
      contentEditable
      suppressContentEditableWarning
      spellCheck={false}
      onBlur={(e) => {
        const txt = e.currentTarget.innerText;
        const clean = multiline ? txt : txt.replace(/\s*\n\s*/g, " ");
        if (clean !== value) update(path, clean);
      }}
    >
      {value}
    </Tag>
  );
};

// Item reorder / delete controls (shown only in edit mode)
export const ListControls = ({ onUp, onDown, onDelete, canUp = true, canDown = true, className = "", testid }) => {
  const { editMode } = useApp();
  if (!editMode) return null;
  return (
    <div className={`edit-controls flex items-center gap-1.5 ${className}`} data-testid={testid}>
      <button type="button" onClick={onUp} disabled={!canUp} className="ec-btn" title="Move up">
        <ArrowUp size={14} />
      </button>
      <button type="button" onClick={onDown} disabled={!canDown} className="ec-btn" title="Move down">
        <ArrowDown size={14} />
      </button>
      <button type="button" onClick={onDelete} className="ec-btn ec-danger" title="Delete">
        <Trash2 size={14} />
      </button>
    </div>
  );
};

export const AddButton = ({ onClick, label, className = "", testid }) => {
  const { editMode } = useApp();
  if (!editMode) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={`add-btn inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-body font-medium ${className}`}
    >
      <Plus size={16} /> {label}
    </button>
  );
};
